<h3 class="mat-dialog-title aip-dialog-title">{{data.title}}</h3>
  <div class="mat-dialog-content aip-dialog-text">
  
  <div [innerHTML]="data.text">  
  </div>

  <ng-container *ngIf="data.loading">
    <div>
      <mat-spinner diameter=50 class="aip-spinner"></mat-spinner>
    </div>
  </ng-container>


</div>
  <div class="mat-dialog-actions" align="end">
    <button mat-raised-button [disabled]="data.loading" class="mat-focus-indicator aip-button" color="primary" (click)="ok()">OK</button>
    <!-- <button class="mat-focus-indicator aip-button-alt mat-raised-button mat-button-base" (click)="cancel()" cdkFocusInitial>Cancel</button> -->
</div>